import { Component, ElementRef, ViewChild, OnInit, Input, Output, EventEmitter, ViewEncapsulation, OnDestroy } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { SearchService } from '.././services/search.service';
import { forEach } from 'lodash';

@Component({
  selector: 'google-property-search',
  templateUrl: './google-property-search.component.html',
  styleUrls: ['./google-property-search.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class GooglePropertySearchComponent implements OnInit, OnDestroy {
  @Input() searchInput = new Subject<string>();
  googlePlaces: Observable<Array<any>>;
  @Output() showSuggestions: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Output() onGooglePropertySearch = new EventEmitter<any>();
  googleProperty: any;
  private subscriptions: any[] = [];
  inProgress: boolean = true;

  constructor(private searchService: SearchService) { }

  ngOnInit() {
    this.googlePlaces = this.searchInput
      .debounceTime(400)
      .switchMap(s => {
        this.inProgress = true;
        if (s) {
          return this.searchService.getGoogleAutocompleteApi(s)
        } else { return Observable.of([]) }
      })
      .do(() => {
        this.inProgress = false;
        this.showSuggestions.emit(true)
      });
  }

  ngOnDestroy() {
    forEach(this.subscriptions, (s) => s.unsubscribe());
    this.subscriptions = [];
    this.onGooglePropertySearch.complete();
  }

  googlePlaceSelected(place: any) {
    this.subscriptions.push(this.searchService.getLatLan(place)
      .subscribe(data => {
        this.googleProperty = { searchType: 'google', propertyName: data.formatted_address, latitude: data.geometry && data.geometry.location && data.geometry.location.lat(), longitude: data.geometry && data.geometry.location && data.geometry.location.lng(), categories: data.types };
        this.onGooglePropertySearch.emit({ property: this.googleProperty });
      },
      error => console.log(error)));
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/search/google-property-search/google-property-search.component.ts